export const getLastGrade = (userId, courseId) => {
  try { return localStorage.getItem(`lastGrade:${userId}:${courseId}`); } catch { return null; }
};

export const setLastGrade = (userId, courseId, grade) => {
  try { localStorage.setItem(`lastGrade:${userId}:${courseId}`, grade); } catch {}
};
